import React, { useRef } from 'react';
import '../css/FooterCTA.css';

const FooterCTA = () => {
  const sliderRef = useRef(null);

  // Sample Accreditation Logos matching the carousel in image 14
  const globalLogos = [
    { id: 1, name: "Bihar Skill Development", url: "https://upload.wikimedia.org/wikipedia/commons/5/52/Emblem_of_Bihar.svg" },
    { id: 2, name: "CLT Ludhiana", url: "https://placehold.co/120x60/ffffff/00254d?text=CLT" },
    { id: 3, name: "IOSH Approved", url: "https://placehold.co/120x60/ffffff/1e88e5?text=iosh" },
    { id: 4, name: "NSDC Corporation", url: "https://placehold.co/120x60/ffffff/ea580c?text=N·S·D·C" },
    { id: 5, name: "NEBOSH Gold", url: "https://placehold.co/120x60/ffffff/000000?text=NEBOSH" }
  ];

  const handleScroll = (direction) => {
    if (sliderRef.current) {
      const scrollAmount = 200;
      sliderRef.current.scrollBy({
        left: direction === 'left' ? -scrollAmount : scrollAmount,
        behavior: 'smooth'
      });
    }
  };

  return (
    <div className="gfi-last-zone-wrapper">
      
      {/* UPPER BLOCK: INDUSTRIAL CALL TO ACTION BANNER */}
      <section className="gfi-cta-banner">
        <div className="gfi-cta-overlay-bg"></div>
        <div className="gfi-cta-container">
          
          <h2 className="gfi-cta-heading">Start Your Career in Fire & Safety Today</h2>
          <p className="gfi-cta-subtext">
            Join Growth Academy Pvt. Ltd. and build a secure future with global certifications and placement support.
          </p>

          {/* DYNAMIC THREE PILL BUTTONS PACK */}
          <div className="gfi-cta-button-group">
            <a href="#apply" className="gfi-pill-btn btn-apply">
              <span className="gfi-pill-icon">📝</span> APPLY NOW
            </a>
            <a href="https://wa.me/1234567890" target="_blank" rel="noreferrer" className="gfi-pill-btn btn-whatsapp">
              <span className="gfi-pill-icon">💬</span> WHATSAPP NOW
            </a>
            <a href="tel:+1234567890" className="gfi-pill-btn btn-call">
              <span className="gfi-pill-icon">📞</span> CALL NOW
            </a>
          </div>

        </div>
      </section>

      {/* LOWER BLOCK: ACCREDITED SLIDER AREA */}
      <section className="gfi-recognition-slider-section">
        <div className="gfi-recognition-container">
          <span className="gfi-recognition-caption">RECOGNIZED BY GLOBAL BODIES</span>
          
          <div className="gfi-slider-outer-frame">
            {/* Left Nav Arrow */}
            <button className="gfi-slider-arrow arrow-left" onClick={() => handleScroll('left')}>&lt;</button>
            
            {/* Scrollable Logos Track */}
            <div className="gfi-logos-scroll-track" ref={sliderRef}>
              {globalLogos.map((logo) => (
                <div key={logo.id} className="gfi-logo-card-frame">
                  <img src={logo.url} alt={`${logo.name} Accreditation Seal`} className="gfi-global-body-img" />
                </div>
              ))}
            </div>

            {/* Right Nav Arrow */}
            <button className="gfi-slider-arrow arrow-right" onClick={() => handleScroll('right')}>&gt;</button>
          </div>
        </div>
      </section>

    </div>
  );
};

export default FooterCTA;